import { render, staticRenderFns } from "./Devoluciones.vue?vue&type=template&id=3bd20696&scoped=true"
import script from "./Devoluciones.vue?vue&type=script&lang=js"
export * from "./Devoluciones.vue?vue&type=script&lang=js"
import style0 from "./Devoluciones.vue?vue&type=style&index=0&id=3bd20696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd20696",
  null
  
)

export default component.exports